import { IActivityHistoryItem, IActivityHistoryItemCollection } from "../../domain/model";
import { addItemsToCollection } from "../add-history-items/add-items-to-collection";

export const addItemToCollection = (
  collections: Record<string, IActivityHistoryItemCollection>,
  id: string,
  item: IActivityHistoryItem,
  componentFactory?: (item: IActivityHistoryItem) => HTMLElement,
) => {
  return addItemsToCollection(collections, id, [item], componentFactory);
};
